<template>
    <div class="container">
        <div class="members__top d-flex justify-space-between">
            <BackButton
                    defaultRoute="/studios/members"
                    defaultText="back-to-members"
            />
            <div class="members__action">
                <router-link to="/studios/members/new-member" class="members__btn btn btn-sm btn-h40 btn-gradient">
                    <span>{{$t('form.register_member')}}</span>
                </router-link>
            </div>

        </div>
        <div class="attention">
            <div class="attention__pic"><img src="@/assets/images/dashboard/info.svg" alt=""></div>
            <div class="attention__text">
                <p v-html="$t('studio.unapproved-members.attention_text')"></p>
            </div>
        </div>

        <Table
                :table-head="head"
                :table-body="body"
                :table-data="tableData"
                :allowTooltip="true"
                :isHover="false"
                :requestFunction="getUnapprovedMembers"
                moreMode="table"
                :isMapOpen="false"
        />
    </div>
</template>


<script>
    import { mapGetters } from 'vuex';
    // import Table from "@/elements/Table/Table";
    import { getUnapprovedMembers } from "@/api/studioServices";
    import Table from "@/elements/Table/Table";

    export default {
        components: {
            Table
            // Table,
        },

        data() {
            return {
                getUnapprovedMembers: getUnapprovedMembers,
            }
        },

        computed: {
            ...mapGetters([
                'tableData',
            ]),

        head() {
            return [
                {
                    name: 'gender',
                    adaptiveMode: 'mobile',
                    width: '43px',
                },
                {
                    name: 'firstName',
                    adaptiveMode: 'mobile',
                },
                {
                    name: 'surname',
                    adaptiveMode: 'mobile',
                },
                {
                    name: 'email',
                    adaptiveMode: 'tablet',
                    width: '180px'
                },
                {
                    name: 'studio',
                    adaptiveMode: 'none',
                },
                {
                    name: 'registered_date',
                    adaptiveMode: 'none',
                },
                {
                    name: 'tooltip',
                    adaptiveMode: 'none',
                    width: '25px'
                },
            ]
        },

        body() {


            let arr = [];
                this.tableData.data && this.tableData.data.forEach(item => {
                    arr.push({
                    gender: item.is_male,
                    firstName: item.first_name,
                    surname: item.last_name,
                    email: item.email,
                    studio: item.studio ? item.studio.title : '',
                    registered_date: item.created_at,
                    tooltip: {
                        id: item.id,
                        unverified: true,
                        name: item.first_name
                    }
                })
            });
            return arr;
        }
    },

    async created() {
        await this.$store.dispatch('PAGINATE', {page: 1, requestFunction: this.getUnapprovedMembers});
    },
    }
</script>

<style lang="sass" scoped>
    .members
        &__top
            +xs
                flex-direction: column
        &__action
            +xs
                margin-top: 16px
</style>